import * as React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Avatar, Typography } from '@mui/material';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { useEffect, useState } from 'react';
import { getSkillsOverview } from 'src/services/skillManagementService';

const SkillsOverview = () => {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    width: 220,
    height: 75
  }));

  const Title = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: 'black',
    fontWeight: 'bold'
  }));

  const [skills, setSkills] = useState({ tec: 1, qa: 0, ba: 0, pm: 0 });

  useEffect(() => {
    getSkillsOverview().then((res) => {
      setSkills((prev) => ({
        ...prev,
        tec: res.data['techCount'],
        qa: res.data['qaCount'],
        ba: res.data['bcCount'],
        pm: res.data['pmCount']
      }));
    });
  }, []);

  return (
    <>
      <Grid container spacing={'2.9rem'}>
        <Grid item xs>
          <Item>
            <Grid container>
              <Grid item>
                <Avatar sx={{ m: 1, bgcolor: '#00B26A' }}>
                  <img
                    width={25}
                    height={25}
                    src={process.env.PUBLIC_URL + '/img/skill.svg'}
                    alt={'logo'}
                  />
                </Avatar>
              </Grid>
              <Grid item>
                <Title>Technology</Title>
                <Typography
                  sx={{
                    color: '#00B26A',
                    fontWeight: 'bold',
                    display: 'flex',
                    flexDirection: 'start',
                    marginLeft: 1,
                    marginTop: -1
                  }}
                >
                  {skills['tec']}
                </Typography>
              </Grid>
            </Grid>
          </Item>
        </Grid>
        <Grid item xs>
          <Item>
            <Grid container>
              <Grid item>
                <Avatar sx={{ m: 1, bgcolor: '#0069E4' }}>
                  <img
                    width={25}
                    height={25}
                    src={process.env.PUBLIC_URL + '/img/skill.svg'}
                    alt={'logo'}
                  />
                </Avatar>
              </Grid>
              <Grid item>
                <Title>Quality Assurance</Title>
                <Typography
                  sx={{
                    color: '#0069E4',
                    fontWeight: 'bold',
                    display: 'flex',
                    flexDirection: 'start',
                    marginLeft: 1,
                    marginTop: -1
                  }}
                >
                  {skills['qa']}
                </Typography>
              </Grid>
            </Grid>
          </Item>
        </Grid>
        <Grid item xs>
          <Item>
            <Grid container>
              <Grid item>
                <Avatar sx={{ m: 1, bgcolor: '#FFC107' }}>
                  <img
                    width={25}
                    height={25}
                    src={process.env.PUBLIC_URL + '/img/skill.svg'}
                    alt={'logo'}
                  />
                </Avatar>
              </Grid>
              <Grid item>
                <Title style={{ marginLeft: -6 }}>Business Consulting</Title>
                <Typography
                  sx={{
                    color: '#FFC107',
                    fontWeight: 'bold',
                    display: 'flex',
                    flexDirection: 'start',
                    marginTop: -1
                  }}
                >
                  {skills['ba']}
                </Typography>
              </Grid>
            </Grid>
          </Item>
        </Grid>
        <Grid item xs>
          <Item>
            <Grid container>
              <Grid item>
                <Avatar sx={{ m: 1, bgcolor: '#ED1C24' }}>
                  <img
                    width={25}
                    height={25}
                    src={process.env.PUBLIC_URL + '/img/skill.svg'}
                    alt={'logo'}
                  />
                </Avatar>
              </Grid>
              <Grid item>
                <Title style={{ marginLeft: -6 }}>Project Management</Title>
                <Typography
                  sx={{
                    color: '#ED1C24',
                    fontWeight: 'bold',
                    display: 'flex',
                    flexDirection: 'start',
                    marginTop: -1
                  }}
                >
                  {skills['pm']}
                </Typography>
              </Grid>
            </Grid>
          </Item>
        </Grid>
      </Grid>
    </>
  );
};

export default SkillsOverview;
